import { usePersonnelDetailsContext } from "../PersonnelDetails"
import { CONST_PAYS_ID_FRANCE, CONST_PERSONNEL_STATUT_STATUT_NON_SALARIE } from "@common-constants/*"
import useUser from "../../../../hooks/useUser"

const InfoPersoViewOnly = () => {
     const context = usePersonnelDetailsContext()
     const details = context.detailsQuery.data
     const { canSeeStaffSensitivePersoInfos } = useUser()
     // Le collaborateur non salarié ne renseigne que l'identité de contact (pas d'état civil, résidence, urgence…).
     const isNonSalarie = details?.personnel?.statut === CONST_PERSONNEL_STATUT_STATUT_NON_SALARIE

     return (
          <>
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Civilité</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.civiliteLabel}</span>
                    </div>
               </div>

               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Prénom NOM</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.prenomNom}</span>
                    </div>
               </div>

               {/* Date de naissance — état civil salarié uniquement */}
               {!isNonSalarie && (
                    <div className="row mb-7">
                         <label className="col-lg-4 fw-bold text-muted">Date naissance</label>
                         <div className="col-lg-8">
                              <span className="fw-bolder fs-6 text-dark">{details?.personnel.dateNaissance?.format("DD/MM/YYYY")}</span>
                         </div>
                    </div>
               )}

               {/* Coordonnées + données sensibles — masquées pour le manager métier */}
               {canSeeStaffSensitivePersoInfos() && (
                    <>
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Email</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">
                              <a className={"text-dark text-hover-primary"} href={`mailto:${details?.personnel.mailPersonnel}`}>
                                   {details?.personnel.mailPersonnel}
                              </a>
                         </span>
                    </div>
               </div>

               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Téléphone</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">
                              <a
                                   href={`tel:${details?.personnel.telPersonnelIndicatif ? details?.personnel.telPersonnelIndicatif.phoneCodeWithPlusPrefix : ""} ${details
                                        ?.personnel.telProfessionnel}`}
                                   className="text-dark text-hover-primary"
                              >
                                   {details?.personnel.telPersonnelIndicatif ? details?.personnel.telPersonnelIndicatif.phoneCodeWithPlusPrefix : ""}{" "}
                                   {details?.personnel.telPersonnel}
                              </a>
                         </span>
                    </div>
               </div>

               {/* État civil, résidence et contact d'urgence — salarié uniquement */}
               {!isNonSalarie && (
                    <>
               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">N° de sécurité sociale</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.nSecuriteSociale}</span>
                    </div>
               </div>

               <h5 className="mt-8 mb-4">Résidence</h5>
               <div className="separator separator-dashed mb-6" />

               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Adresse</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.residenceAdresse}</span>
                    </div>
               </div>

               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Ville et code postal</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">
                              {details?.personnel.residencePays?.id === CONST_PAYS_ID_FRANCE ? details?.personnel?.residenceVilleFrance?.nom : details?.personnel?.residenceVille}{" "}
                              {details?.personnel?.residenceCodePostal}
                         </span>
                    </div>
               </div>

               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Pays</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.residencePays?.nomFr}</span>
                    </div>
               </div>

               <h5 className="mt-8 mb-4">Personne à contacter en cas d'urgence</h5>
               <div className="separator separator-dashed mb-6" />

               <div className="row mb-7">
                    <label className="col-lg-4 fw-bold text-muted">Prénom NOM</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">{details?.personnel.personneToContactUrgencePrenomNom}</span>
                    </div>
               </div>

               <div className="row">
                    <label className="col-lg-4 fw-bold text-muted">Téléphone</label>
                    <div className="col-lg-8">
                         <span className="fw-bolder fs-6 text-dark">
                              <a
                                   href={`tel:${
                                        details?.personnel.personneToContactUrgenceTelIndicatif
                                             ? details?.personnel.personneToContactUrgenceTelIndicatif.phoneCodeWithPlusPrefix
                                             : ""
                                   } ${details?.personnel.personneToContactUrgenceTel}`}
                                   className="text-dark text-hover-primary"
                              >
                                   {details?.personnel.personneToContactUrgenceTelIndicatif ? details?.personnel.personneToContactUrgenceTelIndicatif.phoneCodeWithPlusPrefix : ""}{" "}
                                   {details?.personnel.personneToContactUrgenceTel}
                              </a>
                         </span>
                    </div>
               </div>
                    </>
               )}
                    </>
               )}
          </>
     )
}

export default InfoPersoViewOnly
